import React from 'react';
// Components
import DefaultTooltip from '../../../components/tooltip/DefaultTooltip';
// Enums
import { serviceType } from '../../../utils/Enums';
// Icons
import { FaShieldAlt } from 'react-icons/fa';
import { FaLightbulb, FaInfinity } from 'react-icons/fa6';

const InsuranceIcon = ({ icon }) => {
  return (
    <>
      {icon === serviceType.INSURANCES ? (
        <DefaultTooltip text={'Seguros'}>
          <span>
            <FaShieldAlt className="partner-icon partner-icon--insurance" />
          </span>
        </DefaultTooltip>
      ) : icon === serviceType.ELECTRICITY ? (
        <DefaultTooltip text={'Eletricidade'}>
          <span>
            <FaLightbulb className="partner-icon partner-icon--energy" />
          </span>
        </DefaultTooltip>
      ) : (
        <DefaultTooltip text={'Outros'}>
          <span>
            <FaInfinity className="partner-icon partner-icon--other" />
          </span>
        </DefaultTooltip>
      )}
    </>
  );
};

export default InsuranceIcon;
